<template>
  <div @click="openDialog">
    <div>
      群直播关系
    </div>
    <a-modal
      class="container"
      :title="nickname"
      width="700px"
      @cancel="visible = false"
      :footer="null"
      :visible="visible">
      <div class="table big"><span>群</span><span>直播机器人(位置)</span><span>群机器人（位置）</span></div>
      <div class="table" v-for="item in list" :key="item.index">
        <span>{{item.chatroom_nickname}}</span>
        <span>{{`${item.live_bot_dict.bot_nickname}(${item.live_bot_dict.location})`}}</span>
        <span :class="item.mvp_color">{{`${item.mvp_bot_nickname}(${item.mvp_location})`}}</span>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'ChatroomLiveBot',
  props: {
    clientId: Number,
    nickname: String
  },
  data () {
    return {
      getInfoUrl: global.DOMAIN + 'uclient/get_chatroom_live_bot', // 获取信息
      visible: false,
      list: []
    }
  },
  methods: {
    getList () {
      this.axios.post(this.getInfoUrl, {
        token: sessionStorage.token,
        client_id: this.clientId
      }).then(res => {
        if (res.data.err_code === 0) {
          if (res.data.content.res !== false) {
            this.list = res.data.content.res
            this.handleList()
          }
        } else {
          this.$message.error('查询失败')
        }
      })
    },
    handleList () {
      this.list.forEach(room => {
        room.goodList = []
        room.badList = []
        room.master_bot_info_list.forEach(item => {
          if (item.status === '正常') {
            item.color = 'green'
            room.goodList.push(item)
          } else if (item.status === '异常') {
            item.color = 'red'
            room.badList.push(item)
          }
        })
        room.mvp = room.goodList[0] || room.badList[0] || {location: '无', color: '', bot_nickname: ''}
        room.mvp_location = room.mvp.location
        room.mvp_color = room.mvp.color
        room.mvp_bot_nickname = room.mvp.bot_nickname
      })
      console.log(this.list)
    },
    openDialog () {
      this.visible = true
      this.getList()
    }
  }
}
</script>

<style scoped>
  .table {
    display: flex;
  }
  .table span {
    margin: 5px 10px;
    width: 300px;
  }
  .big {
    font-weight: 600;
  }
  .red {
    color: red;
  }
  .green {
    color: limegreen;
  }
</style>
